import { useSortBy } from "@usereactify/search";
import React, { useCallback, useState } from "react";
import { Dropdown } from "../Dropdown/Dropdown";

export const Sort: React.FC = () => {
  const { sortOption, sortOptions, setSortOption } = useSortBy();

  const [isOpen, setIsOpen] = useState(false);

  const handleSelectChange = useCallback(
    (handle: string) => {
      setSortOption(handle);
      setIsOpen(false);
    },
    [setSortOption]
  );

  // const BtnContent = () => (
  //   <span>
  //     <span className="p">{sortOption?.name}</span>
  //   </span>
  // );

  // const BtnContentMobile = () => (
  //   <>
  //     <span className="font-body text-body inline-flex filter-heading sort-heading">Sort: {sortOption?.name}</span>
  //   </>
  // );

  const DropdownContent = () => (
    <>
      <ul className="no-bullets tag-list tag-list--active-tags">
        {sortOptions.map((sortOption) => (
          <li className="tag small">
            <span className="cursor-pointer" onClick={() => handleSelectChange(sortOption.handle)}>
              {sortOption.name}
            </span>
          </li>
        ))}
      </ul>
    </>
  );

  return (
    <Dropdown
      dropdownIsOpen={isOpen}
      setDropdownIsOpen={setIsOpen}
      btnContent={
        <span className="font-body text-body inline-flex filter-heading sort-heading">Sort: {sortOption?.name}</span>
      }
      dropdownContent={<DropdownContent />}
    />
  );
};
